module.exports = __webpack_public_path__ + "img/zoom-in-orange.5b7f6926.svg";